import React from 'react';
import PartyMaster from './PartyMaster';

function Parties() {
  return (
    <PartyMaster
      title="Parties"
      modalTitle="Add Party"
      addButtonText="Add Party"
      searchPlaceholder="Search parties..."
      partyCategory="PARTIES"
      namePlaceholder="Party name"
    />
  );
}

export default Parties;
